// extracted by mini-css-extract-plugin
export default {"title":"GetSite_title__JZb4x","boxForm":"GetSite_boxForm__H4Vmw","form":"GetSite_form__0QBgl"};